/*global PredictSpring*/
/*eslint max-lines: ["error", 1000]*/

/**
 *  Module for cart
 */
const mustache = require('mustache');

const Cart = function (app) {
  /**
   *  Private Properties/Methods
   */
  const cartUtils = require('./utils')(app);
  const configure = app.configure;
  const $container = app.$container;

  const BUTTON_CONTAINER = '.fc-add-to-cart-container';

  let CartButton;
  let timer;

  function createQuantity() {
    configure.run('createComponent', {
      type: 'quantitySelector',
      container: '.fc-qty-container',
      showLabel: false,
      min: 1,
      max: 10
    }, function (err) {
      if (err) { throw err; }
    });
  }

  function handleAppCartError() {
    const errorMessage = 'Add to Cart failed';
    if (app.mergedParams.deviceType === 'android') {
      PredictSpring.handleError(errorMessage);
    } else {
      if (window.webkit) {
        window.webkit.messageHandlers.handleError.postMessage(errorMessage);
      }
    }
  }

  function handleAppCartSuccess(data, callback) {
    if (app.mergedParams.deviceType === 'android') {
      PredictSpring.handleSuccess(JSON.stringify(data));
    } else {
      if (window.webkit) {
        window.webkit.messageHandlers.handleSuccess.postMessage(data);
      }
    }

    callback();
  }

  function createErrorDialog(errorTitle, errorText) {
    let markup = require(__dirname + '/../../../templates/dialog/enter_text.html');
    const dialogClassName = 'fc-reset-confirm-dialog';
    markup = mustache.render(markup, {
      errorText
    });
    configure.run('createDialog', {
      customClassName: dialogClassName,
      type: 'html',
      innerHTML: markup,
      width: 630,
      title: errorTitle
    }, function (err) {
      app._callback(err);
    });
  }

  function checkMissingText(cb) {
    const attributesToVerify = [],
      missingText = [],
      shortText = [];
    let initialsLength;
    const attributes = app.getRenderableAttributes();
    const minLengthData = app.store.initialsMinLength();
    attributes.map(function (attr) {
      const optionalNone = attr.subAttributes.filter(function (subAttribute) {
        return subAttribute.type === 'text';
      });
      if (optionalNone.length) {
        attributesToVerify.push(attr);
      }
    });
    attributesToVerify.map(function (attribute) {
      const selected = app.helpers.getSelectedValueByAlias(attribute.alias);
      if (selected && selected.metadata && app.utils.getMetaData(selected).require_text && attribute.subAttributes) {
        const textAttributes = attribute.subAttributes.filter(function (subAttribute) {
          return subAttribute.type === 'text' && subAttribute.isVisible;
        });
        textAttributes.map(function (textAttribute) {
          const customAlias = `${attribute.alias}_customization_selection`;
          let fontId;
          try {
            const selectedCustom = app.helpers.getSelectedValueByAlias(customAlias);
            fontId = app.utils.getMetaData(selectedCustom).fontid;
          } catch (err) {
            fontId = null;
          }
          const checkMinLength = fontId && minLengthData && minLengthData.fontId === fontId;
          if (textAttribute.value && !textAttribute.value.text) {
            missingText.push(attribute.name);
          } else if (checkMinLength && textAttribute.value && textAttribute.value.text) {
            // here we assume that only 1 front monogram is possible at a time
            initialsLength = textAttribute.value.text.length;
            shortText.push(attribute.name);
          }
        });
      }
    });

    if (missingText.length) {
      const errorTitle = app.l10n.getLang('missing_text_title', 'Custom text missing');
      const errorText = app.l10n.getLang('missing_text_text', 'Please enter text for the custom panels: ') + missingText.join(', ');
      createErrorDialog(errorTitle, errorText);
      handleAppCartError();
      cb(new Error(errorText));
    } else if (initialsLength && minLengthData && initialsLength < minLengthData.minLength) {
      const errorTitle = app.l10n.getLang('missing_characters_title', 'Missing Characters');
      const errorText = app.l10n.getLang('missing_characters_text', 'Requires more characters for the custom panels: ') +
        shortText.join(', ') +
        app.l10n.getLang('missing_characters_minimum_length', '. Minimum length: ') +
        minLengthData.minLength;
      createErrorDialog(errorTitle, errorText);
      handleAppCartError();
      cb(new Error(errorText));
    }
  }

  function hasSizeSelected() {
    const selectedSize = configure.run('getAttribute', { alias: 'size' }).values.filter(function (value) {
      return value.selected;
    });
    return selectedSize.length > 0;
  }

  function checkSizeSelected(cb) {
    if (!hasSizeSelected()) {
      const missingSizeText = app.l10n.getLang('missing_size_text', 'Please select an available size');
      const sizeError = new Error(missingSizeText);
      app.createDialog.triggerDialog({
        title: app.l10n.getLang('missing_size_title', 'Size Missing'),
        className: 'fc-missing-size',
        text: missingSizeText
      });
      handleAppCartError();
      cb(sizeError);
    }
  }

  function checkOptionBackCap(cb) {
    const selectedHatBack = app.helpers.getSelectedValueByAlias('hat_back');
    if (selectedHatBack && selectedHatBack.vendorId === 'select_option') {
      const missingSizeText = app.l10n.getLang('missing_hat_back_text', 'Please select a customization for hat back.');
      const sizeError = new Error(missingSizeText);
      app.createDialog.triggerDialog({
        title: app.l10n.getLang('missing_hat_back_title', 'Hat Back selection Missing'),
        className: 'fc-missing-size',
        text: missingSizeText
      });
      handleAppCartError();
      cb(sizeError);
    }
  }

  function addPe01Params() {
    const {
      viewOption,
      vendorRef,
      designIndex,
      artworkcolorindex,
      frontText1,
      type1FontIndex,
      type1ThreadColor,
      frontText2,
      type2FontIndex,
      type2ThreadColor,
      backText1,
      backText2,
      designEnabled
    } = app.generateImageUrl.getParams({ viewName: 'front_on_back' });

    return {
      viewOption,
      vendorRef,
      type1Text: frontText1,
      type1ThreadColor,
      type1FontIndex,
      type2Text: frontText2,
      type2FontIndex,
      type2ThreadColor,
      designEnabled,
      designIndex,
      designOption: artworkcolorindex,
      type3Text: backText1,
      type4Text: backText2
    };
  }

  function addDtgParams() {
    const {
      view,
      garmentIndex,
      designindex,
      artworkcolorindex,
      backOption,
      frontText1,
      frontText2,
      backText1,
      backText2
    } = app.generateImageUrl.getParams({ viewName: 'front_on_back' });

    return {
      viewOption: view,
      GarmentIndex: garmentIndex,
      Design: designindex,
      DesignOptionFront: artworkcolorindex,
      DesignOptionBack: backOption,
      Type1: frontText1,
      Type2: frontText2,
      Type3: backText1,
      Type4: backText2,
      locale: app.mergedParams.requestedLocale
    };
  }

  function beforeSave(callback) {
    checkMissingText(callback);
    checkSizeSelected(callback);
    if (app.category === 'Hat') {
      checkOptionBackCap(callback);
    }

    app.updateRecipeOms.updateOmsFields(app.configure.run('getRecipe', 'json'));
    app.updateRecipeOms.clearResidualOmsText();
    app.updateRecipeOms.updateOmsTcBeforeCart();
    app.updateRecipeOms.verifyOmsCt5();

    const custom = {};
    if (!app.appUtils.isDTGProduct()) {
      custom.monogram_initials = app.store.initials();
    } else {
      if (app.appUtils.isPrintAndEmbroideryProduct()) {
        custom.pe01_params = addPe01Params();
      } else {
        custom.dtg_params = addDtgParams();
      }

      custom.sku = app.helpers.getSelectedValueByAlias('size').vendorId;
    }

    callback(null, custom);
  }

  function isCartDisabled() {
    let cartDisabledStatus = false;

    if (app.mergedParams.addToCartInProgress) {
      cartDisabledStatus = true;
    } else if (app.store.monogramUGC() !== 'none' && !app.appUtils.isNonClothingProduct()) {
      cartDisabledStatus = true;
    } else if (app.appUtils.isDTGProduct() && app.mergedParams.dtgDisableCart) {
      cartDisabledStatus = true;
    } else if (app.mergedParams.noColorsAvailable) {
      cartDisabledStatus = true;
    }
    return cartDisabledStatus;
  }

  function updateCartButtonState(forceDisable = false) {
    const $price_wrapper = $container.find(BUTTON_CONTAINER);
    const state = (isCartDisabled() || forceDisable) ? 'disabled' : 'enabled';
    switch (state) {
      case 'enabled':
        $price_wrapper.removeClass('fc-disabled');
        $price_wrapper.addClass('fc-enabled');
        break;
      case 'disabled':
        $price_wrapper.removeClass('fc-enabled');
        $price_wrapper.addClass('fc-disabled');
        break;
    }
  }

  function clearAddingToCartState() {
    clearTimeout(timer);
    app.mergedParams.addToCartInProgress = false;
    app.performance.mark('configure:add-to-cart:end');
    app.performance.record('Cart', 'Total Process', ['configure:add-to-cart:start', 'configure:add-to-cart:end']);
    app.performance.record('Cart', 'Configure Init to Cart Button Click', ['configure:init', 'configure:add-to-cart:start']);
    fluidTimings.finish('add to cart');
    updateCartButtonState();
  }

  function updateSavingCartState(saving = false) {
    configure.run('setComponentOptions', {
      'addToCartButton': {
        'buttonLabel': saving ?
          app.l10n.getLang('adding_to_cart_button_label', 'Add To Bag') :
          app.l10n.getLang('add_to_cart_button_label', 'Add To Bag')
      }
    });
    updateCartButtonState(saving);
  }

  function processRecipe(err, data) {
    if (err) {
      updateSavingCartState(false);
      app.mergedParams.addToCartInProgress = false;
      throw err;
    }
    configure.run('setComponentOptions', { 'dialog': { width: 600 } });

    app.utils.getRecipeJson(data).done(function (recipe) {
      // this would hold the id of the item when we're editing an article from cart.
      if (typeof recipe !== 'undefined' && recipe.hasOwnProperty('id')) {
        let customRecipe = recipe;
        const recipeId = customRecipe.id;

        // If we have a DTG product
        if (app.appUtils.isDTGProduct()) {
          // Get the attributes from the recipe
          const attributes = customRecipe.extended_attributes;
          // Check if the customize_back value exists and if it's blank, or
          // if it exists but there is no value. We would consider this blank.
          const isBlankSelected = (
            (
              attributes.customize_back &&
              attributes.customize_back.value &&
              attributes.customize_back.value.info.vendorId === 'BLANK'
            ) ||
            (
              attributes.customize_back &&
              !attributes.customize_back.value
            )
          );
          // Create our blank object
          const blankObject = (isBlankSelected) ? {
            oms_sz2: 'BLANK',
            oms_pl2: 'BLANK',
            oms_tc2: 'BLANK',
            oms_ct2: 'BLANK'
          } : {};
          // Merge the DTG data and Blank data
          const oms = Object.assign({}, customRecipe.localized_configuration, {
            oms_sz1: 'DTG',
            oms_pl1: 'DTG',
            oms_tc1: 'DTG',
            oms_tx1: recipe.id,
            oms_ct1: 'DTG'
          }, blankObject);
          customRecipe = Object.assign({}, customRecipe, {
            localized_configuration: oms
          });
        }

        const orderItemId = app.mergedParams.orderItemId;
        if (typeof window.configureAddToCart !== 'function' &&
          typeof window.configureEditCart !== 'function') {
          console.log('Add to cart recipe id:', recipeId);
          const recipeUrl = app.utils.getRecipeUrl(recipeId);
          const apiKey = configure.run('getPreferences').apiKey;
          const html = cartUtils.getOmsHtml(customRecipe);

          const customOptions = {
            apiKey,
            addedtocartdialog: {
              recipe: customRecipe,
              recipeUrl,
              locale: 'en_us',
              customHtml: html
            },
            container: '#fluidConfigure'
          };
          if (app.isFluidEnv()) {
            console.log('customRecipe', customRecipe);
          }
          app.addedtocartdialog.create(customOptions);
          clearAddingToCartState();
        } else {
          // we check if the item is being edited from the cart.
          if (orderItemId) {
            window.configureEditCart(customRecipe, orderItemId);
          } else {
            window.configureAddToCart(customRecipe);
          }
          clearAddingToCartState();
        }

        app.analytics.track('add-to-cart', { recipeId: data.id, recipe: customRecipe });

        console.timeEnd('Add to Cart Complete');
      } else {
        configure.run('createDialog', {
          type: 'html', title: 'Attention',
          innerHTML: '<p>' + app.l10n.getLang('cart_add_error', 'There was a problem creating your order. Please try again.') + '</p>'
        });
      }
      updateSavingCartState(false);
    });
  }

  function triggerConfigureAddToCart() {
    console.time('Add to Cart Complete');

    configure.run('addToCart', { beforeSave }, (err, data) => {
      if (err) {
        return;
      }
      const url = window.location.origin + window.location.pathname;
      const searchParams = app.appUtils.parseUrlParams();
      searchParams.recipeId = data.id;
      searchParams.appAction = 'PredictSpringClose';

      const cartObj = {
        predictSpring_recipeId: data.id,
        predictSpring_productId: app.mergedParams.product || app.mergedParams.productId
      };

      if (app.mergedParams.orderItemId) {
        cartObj.predictSpring_orderItemId = app.mergedParams.orderItemId;
      }

      handleAppCartSuccess(cartObj, () => {
        if (app.mergedParams.appRedirect) {
          const queryString = Object.keys(searchParams)
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(searchParams[key]))
            .join('&');
          window.location = `${url}?${queryString}`;
        }
      });
    });
  }

  window.triggerConfigureAddToCart = triggerConfigureAddToCart;
  window.configureParams.doAddToCart = triggerConfigureAddToCart;

  function updateAddToCart() {
    if (app.isAppInstance()) {
      return;
    }
    if (CartButton) {
      CartButton.trigger('destroy');
    }

    updateCartButtonState();
    // Show price for pride project when on mobile
    const showPriceOnButton = (app.utils.isMobile() || app.utils.isVerticalTablet()) && app.projectName.toLowerCase() === 'pride';
    CartButton = configure.run('createComponent', {
      type: 'addToCartButton',
      container: BUTTON_CONTAINER,
      buttonLabel: app.l10n.getLang('add_to_cart_button_label', 'Add To Bag'),
      beforeSave,
      disabled: isCartDisabled(),
      saveOnSelected: false,
      showPriceOnButton
    }, function (err, addToCartButton) {
      addToCartButton.on('selected', function () {
        if (isCartDisabled()) {
          return false;
        }
        timer = setTimeout(clearAddingToCartState, 30000);
        app.performance.mark('configure:add-to-cart:start');
        fluidTimings.start('add to cart');
        app.mergedParams.addToCartInProgress = true;
        addToCartButton.trigger('save');
        updateSavingCartState(true);
        console.time('Add to Cart Complete');
      });

      addToCartButton.on('saved', processRecipe);
    });
  }

  function init() {
    if (app.isAppInstance()) {
      return;
    }
    if (app.mergedParams.showQuantity) {
      createQuantity();
    }
    updateAddToCart();
  }

  /**
   *  Expose Public Properties/Methods
   */
  return {
    init,
    updateAddToCart
  };
};

module.exports = Cart;
